import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpService } from 'src/app/core/data/service/http.service';
import { ServiceHelper } from 'src/app/core/helper/services.helper';

@Injectable({
  providedIn: 'root'
})
export class RefTableService extends HttpService {

  constructor(
    http: HttpClient,
  ) {
    super(http);
  }

  async getOrgTypes() : Promise<OrgType[]>{
    return <OrgType[]>( await this.fetch(`orgtypes`) as OrgType[]);
  }

  async getTemplateCommunities() : Promise<TemplateCommunity[]>{
    return <TemplateCommunity[]>( await this.fetch(`templateCommunities`) as TemplateCommunity[]);
  }

  protected isUpdate(entity: any): boolean {
    throw new Error('Method not implemented.');
  }
  protected getUpdateUrl(entity: any): string {
    throw new Error('Method not implemented.');
  }
}

export class OrgType {
  orgTypeId: number;
  templateCommunityId: number;
  name: string;
  deleted: boolean;
  sortOrder: number;
}

export class TemplateCommunity {
  templateCommunityId: number;
  communityId: number;
  hasEvents: boolean;
  hasShop: boolean;
  hasSponsors: boolean;
  hasStatic: boolean;
  hasFundraising: boolean;
  hasNews: boolean;
  hasResources: boolean;
  hasMemberships: boolean;
  hasNewsletters: boolean;
  isFull: boolean;
  communityUrl: string;
  communityName: string;
  communityDesc: string;
}